import React from 'react';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import {notWebMediaQuery, useIsMobile, webMediaQuery} from '../../../styles';
import LeftDecorator from '../../../assets/show_left_blob.png';
import RightDecorator from '../../../assets/show_right_blob.png';
import VectorLines from '../../../assets/show_lines.svg';
import ButtonShare from '../ButtonShare';

const ComicsFooter = ({comic}) => {
    const {t} = useTranslation();
    const isMobile = useIsMobile();
    return (
        <Container>
            <TitleText>{comic.title}</TitleText>
            <SubtitleText>{comic.subtitle}</SubtitleText>
            <TitleText>{t('comics.about')}</TitleText>
            <DescriptionText>{comic.about}</DescriptionText>
            {!isMobile && (
                <EndPoster>
                    <Char
                        src={`${comic.baseUrl}${comic.characters}`}
                        alt={comic.show}
                    />
                    <Logo src={`${comic.baseUrl}${comic.logo}`} />
                </EndPoster>
            )}
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    padding: 40px 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
`;

const TitleText = styled.div`
    font-family: TTNormsProExtraBlack;
    font-style: normal;
    font-weight: 1000;
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    text-transform: uppercase;
    color: #ffffff;
    margin-bottom: 8px;
`;

const SubtitleText = styled.div`
    font-family: AvenirNextRoundedStd;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.0225em;
    color: #ffffff;
    margin-bottom: 40px;
    max-width: 450px;
`;

const DescriptionText = styled.div`
    font-family: AvenirNextRoundedStd;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    /* or 114% */
    text-align: center;
    letter-spacing: 0.0225em;
    color: #ffffff;
    max-width: 450px;
`;

const EndPoster = styled.div`
    position: relative;
    margin: auto;
    margin-bottom: 56px;
    background-image: url(${LeftDecorator}), url(${RightDecorator});
    background-size: contain, contain;
    background-position: left, right;
    background-repeat: no-repeat;

    width: 100%;
    height: 440px;
    object-fit: contain;
    margin-top: 60px;

    ${webMediaQuery} {
        background-image: url(${VectorLines}), url(${LeftDecorator}),
            url(${RightDecorator});
        background-size: contain, contain, contain;
        background-position: center, left, right top;
    }

    ${notWebMediaQuery} {
        max-width: 100%;
    }
`;

const Char = styled.img`
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
`;

const Logo = styled.img`
    position: absolute;
    width: 60%;
    height: 60%;
    object-fit: contain;
    margin: auto;
    left: 0;
    right: 0;
    bottom: 0;
`;

export default ComicsFooter;
